import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getItemTags, getItemTagsData } from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

type ItemTagsByItemNo = Record<string, string[]>;

export const useItemTagsData = (
  itemNos: string | undefined,
  enabled = true
): UseQueryResult<string[]> => {
  return useQuery<string[], Error>({
    queryKey: [QueryKeys.ItemTags, itemNos],
    queryFn: () => getItemTags(itemNos || ""),
    enabled: enabled && !!itemNos,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};

export const useItemTagsByItemNos = (
  itemNos: string | undefined,
  enabled = true
): UseQueryResult<ItemTagsByItemNo> => {
  return useQuery<ItemTagsByItemNo, Error>({
    queryKey: [QueryKeys.ItemTagsByItemNo, itemNos],
    queryFn: async () => {
      const itemTags = await getItemTagsData(itemNos || "");

      return itemTags.reduce<ItemTagsByItemNo>((itemTagsByItemNo, item) => {
        itemTagsByItemNo[item.itemNo] = Array.from(
          new Set([
            ...(itemTagsByItemNo[item.itemNo] ?? []),
            ...(item.tags ?? []),
          ])
        );
        return itemTagsByItemNo;
      }, {});
    },
    enabled: enabled && !!itemNos,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
